/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core'; 
import HourInput from 'components/atoms/Form/HourInput';
import SelectForm from 'components/molecules/SelectForm';
import { SalaryBusinessStaff } from 'domain/master/general/salaryDataStaff';
import { OptionType } from 'components/atoms/Select';
import { SubActionButton } from 'components/atoms/Button';

const SalaryBusinessForm: React.FC<{
  businessOptions: Array<OptionType>;
  salaryBusiness: SalaryBusinessStaff;
  setSalaryBusiness: (salaryBusiness: SalaryBusinessStaff) => void;
  deleteSalaryBusiness: () => void;
}> = ({
  businessOptions, salaryBusiness, deleteSalaryBusiness, setSalaryBusiness,
}) => (
      <tr>
        <td style={{ textAlign: 'center' }}>
          <SubActionButton action={1} text="削除" onClick={deleteSalaryBusiness} />
        </td>
        <td>
          <SelectForm
            label=""
            isHiddenLabel={true}
            name="businessId"
            value={salaryBusiness.id.businessId}
            setValue={(v) => {
              setSalaryBusiness({
                ...salaryBusiness,
                id: {
                  staffSalaryId: salaryBusiness.id.staffSalaryId,
                  businessId: v,
                },
              });
            }}
            options={businessOptions}
          />
        </td>
        <td>
          <HourInput
            name="selectSalary.limitTransportation"
            value={salaryBusiness.addHourlySalary}
            label="円"
            onChange={(e) => {
              setSalaryBusiness({
                ...salaryBusiness,
                addHourlySalary: Number(e.target.value),
              });
            }}
            min={0}
            max={99999999}
          />
        </td>
      </tr>
    );

export default SalaryBusinessForm;
